module.exports = __webpack_public_path__ + "static/HomepageWomanOnBalcony-fea02fea813360b6e720353d990e7cc2.jpg";